import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Button } from '@change/ds-core-ui';

import { CustomFileInput } from './CustomFileInputSunrise';

type Props = {
	uppy: Uppy<Meta, Body>;
	fileInputId: string;
	onButtonClick?: () => void;
	uploadButtonText?: string;
};

export const AccessibleFileInputWrapper: React.FC<Props> = ({
	uppy,
	fileInputId,
	onButtonClick,
	uploadButtonText = 'Upload',
}) => {
	// render the upload button as a <label> tied to the hidden file input
	const buttonComponentOverrides = {
		as: 'label',
		htmlFor: fileInputId,
		role: '',
	} as unknown as EmptyProps;

	return (
		<>
			<CustomFileInput onButtonClick={onButtonClick} fileInputId={fileInputId} uppy={uppy} />
			<Button
				{...buttonComponentOverrides}
				variant="primary"
				tabIndex={-1}
				aria-controls={fileInputId}
				className="image-uploader-upload-button"
			>
				{uploadButtonText}
			</Button>
		</>
	);
};
